import API from '@/services/api.js'

const actions = {
  //- Sets the states
  setStates({commit}, states) {
    console.log('Store - setStates')
    //- Mutate store
    commit('SET_STATES', states)
  },
  //- Sets the professions
  setProfessions({commit}, professions) {
    console.log('Store - setProfessions')
    //- Mutate store
    commit('SET_PROFESSIONS', professions)
  },
  setAllProfessions({commit}, allProfessions) {
    console.log('Store - setAllProfessions')
    //- Mutate store
    commit('SET_ALL_PROFESSIONS', allProfessions)
  },
  //- Sets the regions
  setRegions({commit}, regions) {
    console.log('Store - setRegions')
    //- Mutate store
    commit('SET_REGIONS', regions)
  },
  setRegionaryEmails({commit}, regionaryEmails) {
    console.log('Store - regionaryEmails')
    //- Mutate store
    commit('SET_REGIONARY_EMAILS', regionaryEmails)
  },
  setEmploymentTypes({commit}, EmploymentTypes) {
    console.log('Store - setRegions')
    //- Mutate store
    commit('SET_EMPLOYMENT_TYPES', EmploymentTypes)
  },
  setDistanceOrderStates({commit}, orderStates) {
    console.log('Store - setDistanceOrderStates')
    //- Mutate store
    commit('SET_DISTANCE_ORDER_STATES', orderStates)
  },
  setExtensionOrderStates({commit}, orderStates) {
    console.log('Store - setExtensionOrderStates')
    //- Mutate store
    commit('SET_EXTENSION_ORDER_STATES', orderStates)
  },
  setSystemSettings ({ commit }, settings) {
    console.log('Store - setSystemSettings')
    //- Mutate store
    commit('SET_SYSTEM_SETTINGS', settings)
  },
  setBasicsLoaded ({ commit }, isLoaded) {
    console.log('Store - setBasicLoaded')
    //- Mutate store
    commit('SET_LOADED', isLoaded)
  },

  loadBasics({dispatch}) {
    console.log('Store - loadBasics - states')
    Promise.all([
      API.listApplicationStates()
        .then(response => {
          return dispatch('setStates', response.data)
        }),
      API.listProfessions()
        .then(response => {
          return dispatch('setProfessions', response.data)
        }),
      API.listAllProfessions()
        .then(response => {
          return dispatch('setAllProfessions', response.data)
        }),
      API.listRegions()
        .then(response => {
          return dispatch('setRegions', response.data)
        }),
      API.listEmploymentTypes()
        .then(response => {
          return dispatch('setEmploymentTypes', response.data)
        }),
      API.listDistanceOrderStates()
        .then(response => {
          return dispatch('setDistanceOrderStates', response.data)
        }),
      API.listExtensionOrderStates()
        .then(response => {
          return dispatch('setExtensionOrderStates', response.data)
        }),
      API.getSystemSettings()
        .then(response => {
          return dispatch('setSystemSettings', response.data)
        })
    ])
      .then(res => {
        return dispatch('setBasicsLoaded', true)
      })
      .catch(error => {
        console.log('There was an error fetching DistanceOrderStates:', error)
      })
  }
}

export default actions
